import { Component, OnInit, OnChanges, OnDestroy, Input } from '@angular/core';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule, SelectItem, MenuItem } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from '../../../../theme/services/notifications/notifications.service';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { config } from '../../../../../environments/config';
import { UploadFilesService } from '../../service/upload-files/upload-files.service';

import { MedicalCase } from '../../class/medical-case';

import { Candidate } from '../../class/candidate';

import { MedicalCasesService } from '../../service/medical-cases/medical-cases.service';

import { ContractService } from '../../service/contract/contract.service';
import { CandidateService } from '../../service/candidate/candidate.service';
import { CustomerGuideService } from '../../service/customer-guide/customer-guide.service';

import { formatDate } from '../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../theme/functions/calendarES';
import { MedicalCaseEventCandidateSharedService } from '../../service/medical-case-event-candidate/medical-case-event-candidate-shared.service';


@Component({
  selector: 'app-medical-cases',
  templateUrl: './medical-cases.component.html',
  styleUrls: ['./medical-cases.component.scss']
})
export class MedicalCasesComponent implements OnInit {
  @Input() identification_number: string;

  public apiUrl = config.API_ROOT;

  public modNew = false;
  public modView = false;

  public medicalCases: MedicalCase[];

  public candidate: Candidate[];

  public loading: boolean = true;

  public page: number;
  public per_page: number;
  public sort: string;
  public query: string;
  public candidate_id: number;

  public es: any;

  public msgs: Message[] = [];

  public myEmployeeId: string;

  public filters: any[];

  public first = 0;
  public totalRecords: number;

  public form1: FormGroup;
  public form2: FormGroup;

  public modExportReport: boolean;

  public formWhatsApp: FormGroup;
  public modViewDialogWhatsapp: boolean = false;

  public modViewDialogCandidate: boolean = false;
  public sticky: boolean = false;
  public selectCandidate: Candidate;
  public statusOptions: any[];
  ReportTypeExportOptions: { label: string; value: string; }[];

  constructor(
    public confirmationService: ConfirmationService,
    public translate: TranslateService,
    public activatedRoute: ActivatedRoute,
    public hasPermissionService: HasPermissionService,
    public fb: FormBuilder,
    private notificationsService: NotificationsService,
    public uploadFilesService: UploadFilesService,
    public candidateService: CandidateService,
    public contractService: ContractService,
    public customerGuideService: CustomerGuideService,
    public router: Router,
    private medicalCaseEventCandidateSharedService: MedicalCaseEventCandidateSharedService,
    public medicalCasesService: MedicalCasesService,
  ) {
    // this.loading = false;
    this.page = 1;
    this.per_page = 10;
    this.sort = '-id';

    this.es = calendarES();
  }

  ngOnInit() {
    this.page = 1;
    this.per_page = 10;
    this.sort = '-id';

    this.myEmployeeId = JSON.parse(localStorage.getItem('profile')).employee_id;
    this.statusOptions = [
      {label: 'Todos', value: ''},
      {label: 'Abierto', value: 'Abierto'},
      {label: 'Cerrado', value: 'Cerrado'},
    ];
    this.ReportTypeExportOptions = [
      {label: 'Reporte Casos Médicos - General', value: 'Reporte Casos Médicos - General'},
      {label: 'Reporte Casos Médicos - Seguimientos', value: 'Reporte Casos Médicos - Seguimientos'},
      
  ];
    this.createForm1();
    this.createForm2();

    this.createFormWhatsApp();
  }

  createForm1(data:any = null){
    data = data || {
      company_id_filter : '',
      candidate_id_filter : '',
      venue_id_filter : '',
      status_filter : '',
      last_next_monitoring_date_filter_min: '',
      last_next_monitoring_date_filter_max: '',
    };

    this.form1 = this.fb.group({
      company_id_filter : new FormControl(data.company_id_filter),
      candidate_id_filter : new FormControl(data.candidate_id_filter),
      venue_id_filter : new FormControl(data.venue_id_filter),
      status_filter: new FormControl(data.status_filter),
      last_next_monitoring_date_filter_min: new FormControl(data.last_next_monitoring_date_filter_min),
      last_next_monitoring_date_filter_max: new FormControl(data.last_next_monitoring_date_filter_max)
    });
  }

  createForm2(data:any = null){
    data = data || {
      export_candidate_id: '',
      export_status: '',
      export_company_id: '',
      export_venue_id: '',
      export_date_start: '',
      export_date_end: '',
      export_type_filter: ''
    };

    this.form2 = this.fb.group({
      export_candidate_id: new FormControl( data.export_candidate_id ),
      export_status: new FormControl( data.export_status ),
      export_company_id: new FormControl( data.export_company_id ),
      export_venue_id: new FormControl( data.export_venue_id ),
      export_date_start: new FormControl( data.export_date_start, Validators.compose([ Validators.required ]) ),
      export_date_end: new FormControl( data.export_date_end, Validators.compose([ Validators.required ]) ),
      export_type_filter: new FormControl( data.export_type_filter, Validators.compose([ Validators.required ]) ),
    });
  }

  createFormWhatsApp(data:any = null){
    data = data || {
      mobile_send : '',
      message_send : '',
    };

    this.formWhatsApp = this.fb.group({
      mobile_send : new FormControl(data.mobile_send, Validators.compose([ Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$') ]) ),
      message_send : new FormControl(data.message_send, Validators.compose([ Validators.required, Validators.minLength(7) ]) ),
    });
  }

  public filter (values?, pageRefresh?) {
    // this.page = 1;
    this.first = 0;

    this.filters = [];

    if (values.candidate_id_filter !== 'all' && values.candidate_id_filter !== '')
      this.filters.push({'key': 'candidate_id-lk', 'value': values.candidate_id_filter.id});

    if (values.company_id_filter !== 'all' && values.company_id_filter !== '')
      this.filters.push({'key': 'company_id-lk', 'value': values.company_id_filter.id});

    if (values.venue_id_filter)
      this.filters.push({'key': 'venue_id-lk', 'value': values.venue_id_filter});

    if (values.status_filter && values.status_filter !== '')
      this.filters.push({'key': 'status-in', 'value': values.status_filter});

    if (values.last_next_monitoring_date_filter_min && values.last_next_monitoring_date_filter_min!='')
      this.filters.push({'key':'last_next_monitoring_date-min', 'value': this.constDatesFilter(values.last_next_monitoring_date_filter_min,true,false)});

    if (values.last_next_monitoring_date_filter_max && values.last_next_monitoring_date_filter_max!='')
      this.filters.push({'key':'last_next_monitoring_date-max', 'value': this.constDatesFilter(values.last_next_monitoring_date_filter_max,false,false)});

    this.getMedicalCases();
  }

  public getMedicalCases(query?: string) {
    this.loading = true;
    this.medicalCasesService.getMedicalCases(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
      response => {
        this.loading = false;

        this.medicalCases = response.json().data;
        
        if (response.json().meta.total > response.json().meta.total_filtered)
          this.totalRecords = response.json().meta.total_filtered;
        else
          this.totalRecords = response.json().meta.total;
      },
      error => {
        this.loading = false;
        this.msgs = [];
        this.msgs.push( { severity: 'error', summary: 'error' } );
      }
    );
  }

  public loadMedicalCasesLazy(event: LazyLoadEvent) {
    this.page = (event.first / this.per_page) + 1;

    if (event.sortOrder === -1)
      this.sort =  '-' + event.sortField;
    else
      this.sort =  event.sortField;

    if (event.globalFilter)
      this.query = event.globalFilter;
    else
      this.query = undefined;

    this.sort = '-id';

    this.filter(this.form1.value);
  }

  public showExportReport() {
    this.modExportReport = true;
  }

  public exportReportExcel(values) {
    let token = localStorage.getItem('token');
    const export_date_start = this.constDatesFilter(values.export_date_start,true,false);
    const export_date_end = this.constDatesFilter(values.export_date_end,false,false);

    let url = this.apiUrl + '/medical-cases/excel?' +
    'token=' + token + '&_page=1&';

    if (export_date_start)
      url += 'date_start-min=' + export_date_start + '&';

    if (export_date_end)
      url += 'date_start-max=' + export_date_end + '&';

    if (values.export_venue_id)
      url += 'venue_id-in=' + values.export_venue_id + '&';

    if (values.export_candidate_id)
      url += 'candidate_id=' + values.export_candidate_id.id + '&';

    if (values.export_company_id)
      url += 'company_id-in=' + values.export_company_id.id + '&';

    if (values.export_status)
      url += 'status-in=' + values.export_status + '&';
    if (values.export_type_filter)
      url += 'type=' + values.export_type_filter.value + '&';

    window.open(url, '_blank');

    this.modExportReport = false;
  }

  public viewDialogCandidate(id: number, sticky: boolean) {
    this.candidateService.infoCandidate(id).toPromise().then(
        response => {
            this.selectCandidate = response.json();
            this.modViewDialogCandidate = true;
            this.sticky = sticky;
        },
        error => {
            this.msgs = [];
            this.msgs.push( { severity: 'error', summary: 'error' } );
        }
    );
  }

  public viewDialogWhatsapp(values: any, sticky: boolean) {
    this.selectCandidate = values;
    this.formWhatsApp.get('mobile_send').setValue(values.mobile);
    this.formWhatsApp.get('message_send').setValue("Cordial saludo estimado(a) " + values.candidate_name);
    this.modViewDialogWhatsapp = true;
    this.sticky = sticky;
  }

  openWhatsapp(event) {
    window.open('https://api.whatsapp.com/send?phone=' + '57' + event.mobile_send + '&text=' + event.message_send, '_blank');
  }

  public gotoMedicalCaseEvents(medical) {
    this.medicalCaseEventCandidateSharedService.setCandidate(medical);
    this.router.navigate(['/pages/medical-cases/events/'+ medical.candidate_id]);
  }

  constDatesFilter(dateFilter: any, zero: boolean, gmt: boolean){
    let d = new Date(dateFilter);
    if(zero)
    {
      d.setHours(0);
      d.setMinutes(0);
      d.setSeconds(0);
      d.setMilliseconds(0);
    }
    else
    {
      d.setHours(23);
      d.setMinutes(59);
      d.setSeconds(59);
      d.setMilliseconds(59);
    }
    if(gmt)
        return d.toISOString();
    return formatDate(d);
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/medical-cases/medical-cases.component.ts